import {useState} from "react";

interface HasDataIds {
    dataIds: number[];
}

export function useKeySelection<T extends HasDataIds>() {
    const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

    function getKey(item: T): string {
        return item.dataIds.join(',');
    }

    function toggleSelect(item: T) {
        const key = getKey(item);
        setSelectedKeys(prev =>
            prev.includes(key)
                ? prev.filter(k => k !== key)
                : [...prev, key]
        );
    }

    function isSelected(item: T): boolean {
        return selectedKeys.includes(getKey(item));
    }

    function clearSelection() {
        setSelectedKeys([]);
    }

    return {selectedKeys, getKey, toggleSelect, isSelected, clearSelection};
}
